const FW = 89;
const FH = 100;
const OFF = 5;
const VB_W = FW + OFF * 2;
const VB_H = FH + OFF * 2;
const R = 3.8;

const HIGHLIGHT = "#f59e0b";
const ASSIGNED = "rgba(255,255,255,0.35)";
const EMPTY = "rgba(255,255,255,0.12)";

function parsePercent(val) {
  return Number(String(val || "50").replace("%", ""));
}

function formatPos(name, side) {
  if (!name) return "";
  const initials = name.split("_").map((w) => w[0].toUpperCase()).join("");
  if (!side || side === "center") return initials;
  return side[0].toUpperCase() + "_" + initials;
}

export default function FormationPitchSelector({
  formationName,
  formationsCatalog,
  teamSupertracks,
  positionsByUid,
  selectedUid,
  onSelect,
  onAssign,
  onClear,
}) {
  if (!formationName || !formationsCatalog) {
    return (
      <div className="text-center text-muted py-4" style={{ fontSize: 12 }}>
        No formation set
      </div>
    );
  }

  const formation = formationsCatalog.find((f) => f.name === formationName);
  if (!formation?.slots?.length) {
    return (
      <div className="text-center text-muted py-4" style={{ fontSize: 12 }}>
        Formation "{formationName}" not found
      </div>
    );
  }

  const slots = formation.slots.map((slot) => ({
    name: slot.name,
    side: slot.side,
    code: slot.code,
    label: formatPos(slot.name, slot.side),
    cx: OFF + (parsePercent(slot.ui_x) / 100) * FW,
    cy: OFF + (parsePercent(slot.ui_y) / 100) * FH,
  }));

  const stByPos = {};
  if (teamSupertracks && positionsByUid) {
    for (const st of teamSupertracks) {
      const pos = positionsByUid[st.super_track_uid];
      if (pos?.name) {
        const key = `${pos.name}|${pos.side}`;
        if (!stByPos[key]) stByPos[key] = st;
      }
    }
  }

  const handleCircleClick = (slot, st) => {
    if (!selectedUid) {
      if (st) onSelect?.(st.super_track_uid);
      return;
    }
    if (st && st.super_track_uid === selectedUid) {
      onClear?.();
    } else {
      const displacedUid = st?.super_track_uid ?? null;
      onAssign?.(slot.name, slot.side, displacedUid, slot.code);
    }
  };

  const penW = FW * 0.59;
  const penH = FH * 0.18;
  const goalW = FW * 0.27;
  const goalH = FH * 0.07;
  const circleR = Math.min(FW, FH) * 0.11;

  return (
    <svg
      viewBox={`0 0 ${VB_W} ${VB_H}`}
      style={{ width: "100%", maxWidth: 340, background: "#1a472a", borderRadius: 8 }}
    >
      {/* Field border */}
      <rect x={OFF} y={OFF} width={FW} height={FH}
        fill="none" stroke="#3d8b37" strokeWidth={0.5} />
      {/* Center line */}
      <line x1={OFF} y1={OFF + FH / 2} x2={OFF + FW} y2={OFF + FH / 2}
        stroke="#3d8b37" strokeWidth={0.4} />
      {/* Center circle */}
      <circle cx={OFF + FW / 2} cy={OFF + FH / 2} r={circleR}
        fill="none" stroke="#3d8b37" strokeWidth={0.4} />
      {/* Top penalty area */}
      <rect x={OFF + (FW - penW) / 2} y={OFF} width={penW} height={penH}
        fill="none" stroke="#3d8b37" strokeWidth={0.4} />
      <rect x={OFF + (FW - goalW) / 2} y={OFF} width={goalW} height={goalH}
        fill="none" stroke="#3d8b37" strokeWidth={0.4} />
      {/* Bottom penalty area */}
      <rect x={OFF + (FW - penW) / 2} y={OFF + FH - penH} width={penW} height={penH}
        fill="none" stroke="#3d8b37" strokeWidth={0.4} />
      <rect x={OFF + (FW - goalW) / 2} y={OFF + FH - goalH} width={goalW} height={goalH}
        fill="none" stroke="#3d8b37" strokeWidth={0.4} />

      {slots.map((slot, i) => {
        const posKey = `${slot.name}|${slot.side}`;
        const st = stByPos[posKey];
        const isSelected = st != null && st.super_track_uid === selectedUid;
        const hasPlayer = st != null;

        return (
          <g
            key={i}
            style={{ cursor: "pointer" }}
            onClick={() => handleCircleClick(slot, st)}
          >
            <circle cx={slot.cx} cy={slot.cy} r={R}
              fill={isSelected ? HIGHLIGHT : hasPlayer ? ASSIGNED : EMPTY}
              stroke={isSelected ? "#fff" : hasPlayer ? "rgba(255,255,255,0.7)" : "rgba(255,255,255,0.3)"}
              strokeWidth={isSelected ? 0.6 : 0.4}
            />
            <text x={slot.cx} y={slot.cy + 0.3} textAnchor="middle" dominantBaseline="central"
              fontSize={2.8} fontWeight={600} fill="#fff">
              {st?.jersey ?? ""}
            </text>
            <text x={slot.cx - R - 1} y={slot.cy + 0.3} textAnchor="end" dominantBaseline="central"
              fontSize={2} fill="rgba(255,255,255,0.6)" fontWeight={500}>
              {slot.label}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
